import { NerdNavigationBar } from "@nerdjs/nerd-ui";
import { ReactElement } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RouterConfig } from "../config/routerConfig";
import { Typography } from "@mui/joy";
import { usePro } from "../usePro/usePro";

/**
 *
 * @component
 * @example
 * <MainDrawer/>
 * @returns {ReactElement | null} MainDrawer component
 */
export function MainMenu(): ReactElement | null {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const navigate = useNavigate();
  const pro = usePro();

  const leftItems = [
    {
      title: "Journal",
      action: () => {
        navigate(RouterConfig.journal);
      },
      startDecorator: <i className="fa-regular fa-list"></i>,
      selected: pathnames[0] === RouterConfig.journal.slice(1),
    },
    {
      title: "Insights",
      action: () => {
        navigate(RouterConfig.insights);
      },
      startDecorator: <i className="fa-regular fa-chart-line"></i>,
      selected: pathnames[0] === RouterConfig.insights.slice(1),
    },
    {
      title: "Calendar",
      action: () => {
        navigate(RouterConfig.calendar);
      },
      startDecorator: <i className="fa-regular fa-calendar"></i>,
      selected: pathnames[0] === RouterConfig.calendar.slice(1),
    },
    {
      title: "ICS Subscription",
      action: () => {
        navigate(RouterConfig.icsSubscription);
      },
      startDecorator: <i className="fa-solid fa-rss"></i>,
      selected: pathnames[0] === RouterConfig.icsSubscription.slice(1),
    },
    {
      title: "Profile",
      action: () => {
        navigate(RouterConfig.profile);
      },
      startDecorator: <i className="fa-regular fa-user"></i>,
      selected: pathnames[0] === RouterConfig.profile.slice(1),
    },
    // {
    //   title: "Pieces",
    //   action: () => {
    //     navigate(RouterConfig.gigPieces);
    //   },
    //   startDecorator: <i className="fa-regular fa-feather"></i>,
    //   selected: pathnames[0] === RouterConfig.gigPieces.slice(1),
    // },
    {
      title: "Services",
      action: () => {
        navigate(RouterConfig.services);
      },
      startDecorator: <i className="fa-regular fa-violin"></i>,
      selected: pathnames[0] === RouterConfig.services.slice(1),
    },
    {
      title: "Projects",
      action: () => {
        navigate(RouterConfig.projects);
      },
      startDecorator: <i className="fa-regular fa-folder"></i>,
      selected: pathnames[0] === RouterConfig.projects.slice(1),
    },
    {
      title: "Seasons",
      action: () => {
        navigate(RouterConfig.seasons);
      },
      startDecorator: <i className="fa-regular fa-ticket"></i>,
      selected: pathnames[0] === RouterConfig.seasons.slice(1),
    },
    {
      title: "Venues",
      action: () => {
        navigate(RouterConfig.venues);
      },
      startDecorator: <i className="fa-regular fa-map-pin"></i>,
      selected: pathnames[0] === RouterConfig.venues.slice(1),
    },
    {
      title: "Organizations",
      action: () => {
        navigate(RouterConfig.contractors);
      },
      startDecorator: <i className="fa-regular fa-globe"></i>,
      selected: pathnames[0] === RouterConfig.contractors.slice(1),
    },
    {
      title: "Emails",
      action: () => {
        navigate(RouterConfig.emails);
      },
      startDecorator: <i className="fa-regular fa-paper-plane"></i>,
      selected: pathnames[0] === RouterConfig.emails.slice(1),
    },
    {
      title: "Settings",
      action: () => {
        navigate(RouterConfig.settings);
      },
      startDecorator: <i className="fa-regular fa-gear"></i>,
      selected: pathnames[0] === RouterConfig.settings.slice(1),
    },
  ];

  return (
    <NerdNavigationBar
      navigationBarIndex={1}
      chipVariant="plain"
      selectedChipVariant="solid"
      rightItems={[]}
      leftItems={leftItems}
    />
  );
}
